import { autoinject, computedFrom } from "aurelia-framework";
import { Router } from "aurelia-router";
import { Structure } from "../../models/structure";
import { Zone } from "../../models/zone";
import { Location } from "../../models/location";
import { Store } from "aurelia-store";
import { IState } from "../../store/state";
import { Subscription } from "rxjs";
import { AsEnumerable } from "linq-es2015/lib/linq";
import { StatusColors } from "../common/status-colors";
import { I18N } from "aurelia-i18n";

@autoinject
export class StructureCard {
	structure: Structure;
	zone: Zone;
	location: Location;
	structureDoesNotHaveDevices: boolean = false;
	structureHasDevices: boolean = false;

	applicationState: IState;
	private subscription: Subscription;

	constructor(private store: Store<IState>, private router: Router, private i18n: I18N) {

	}

	bind(bindingContext: any, overrideContext: any) {
		this.zone = overrideContext.parentOverrideContext.bindingContext.zone;
		this.subscription = this.store.state.subscribe((state) => this.applicationState = state);
		this.structure = bindingContext.structure;
		this.structureDoesNotHaveDevices = this.structure && this.structure.devices.length === 0;
		this.structureHasDevices = !this.structureDoesNotHaveDevices;
	}

	@computedFrom('structure.notificationStatus')
	get notificationIcon(): string {

		if (!this.structure){
			return null;
		}
		
		switch(this.structure.notificationStatus) {
		case 0:
			return "mdi-bell-off";
		case 1:
			return "mdi-bell-ring";
		case 2:
			return "mdi-bell-sleep";
		default:
			return "mdi-bell-off";
		}
	}

	@computedFrom('structure.notificationStatus')
	get notificationTest(): string {

		if (!this.structure) {
			return null;
		}

		switch (this.structure.notificationStatus) {
		case 0:
			return this.i18n.tr("disabled");
		case 1:
			return this.i18n.tr("enabled");
		case 2:
			return this.i18n.tr("paused");
		default:
			return this.i18n.tr("disabled");
		}
	}
	
	unbind() {
		this.subscription.unsubscribe();
	}

	@computedFrom('zone')
	get columnCss(): string {
		if (this.zone !== undefined && this.zone.isWeatherZone) {
			return "s12";
		}
		return "xxl-3 xl4 l4 m6 s12";
	}
	
	// NB:  need to set the 'statusColor' get method and 'structure.statusColor' in order to 
	// toggle the indicator visibility and support the quick-indicators
	@computedFrom('applicationState.locationState')
	get statusColor() : string {
		if (this.structure === undefined || this.structure.devices === undefined) {
			return null;
		}

		const devices = AsEnumerable(this.structure.devices);

		if (devices.Any(device => device.hasChildren)) {

			const childDevices = devices.SelectMany(device => device.children);
			if (childDevices.Any(device => device.deviceStyle === StatusColors.red)) {
				this.structure.statusColor = StatusColors.red;
				return StatusColors.red;
			}

			if (childDevices.Any(device => device.deviceStyle === StatusColors.yellow)) {
				this.structure.statusColor = StatusColors.yellow;
				return StatusColors.yellow;
			}

			if (childDevices.Any(device => device.deviceStyle === StatusColors.green)) {
				this.structure.statusColor = StatusColors.green;
				return StatusColors.green;
			}
		}

		if (devices.Any(device => device.deviceStyle === StatusColors.red)) {
			this.structure.statusColor = StatusColors.red;
			return StatusColors.red;
		}

		if (devices.Any(device => device.deviceStyle === StatusColors.yellow)) {
			this.structure.statusColor = StatusColors.yellow;
			return StatusColors.yellow;
		}

		if (devices.Any(device => device.deviceStyle === StatusColors.green)) {
			this.structure.statusColor = StatusColors.green;
			return StatusColors.green;
		}
		this.structure.statusColor = null;
		return null;
	}

	@computedFrom('statusColor')
	get indicatorVisibility(): boolean {
		return (this.statusColor !== StatusColors.green && this.statusColor !== null);
	}

	navigateToDetails(event) {
		const tags = ["BUTTON", "MD-SWITCH", "GREENHOUSE", "greenhouse", "dryer", "DRYER", "dryer-header", "DRYER-HEADER"];

		// Hack around browsers which do not support event.path
		const path = event.path || (event.composedPath && event.composedPath());
		const node = path.find(p => tags.indexOf(p.tagName) > -1);

		if (node) {
			return false;
		}
				
		if (this.structure.devices.length) {
			const metadata = this.structure.devices[0].metadata;
			if (metadata) {
				this.router.navigateToRoute("structure-detail",
					{
						locationId: metadata.locationId,
						zoneId: metadata.zoneId,
						structureId: metadata.structureId,
					});
			} else {
				this.router.navigateToRoute("structure-detail",
					{
						locationId: this.zone.locationId,
						zoneId: this.zone.id,
						structureId: this.structure.id,
					});
			}
			
		} else {
			this.router.navigateToRoute("structure-detail",
				{
					locationId: this.zone.locationId,
					zoneId: this.zone.id,
					structureId: this.structure.id,
				});
		}
	}
}